import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { Carousel, Col, Stack, Row } from "react-bootstrap";
import ClipLoader from "react-spinners/ClipLoader";
import { useParams } from "react-router-dom";

const override = {
  display: "block",
  margin: "0 auto",
};

const SliderDroppoints = () => {
  const [loading, setLoading] = useState(false);
  const nexttime = 7000;
  const [droppoints, setDroppoints] = useState([]);
  const [bicycles, setBicycles] = useState([]);
  var carousels = [];
  const { apiKey } = useParams();

  const getData = async () => {
    setLoading(true);
    const resdroppoints = await fetch("api/Droppoint/GetDroppoint/" + apiKey);
    const resbicycles = await fetch(
      "api/Droppoint/GetBicyclesTenant/" + apiKey
    );

    if (resdroppoints.ok && resbicycles.ok) {
      const datadroppoints = await resdroppoints.json();
      const databicycles = await resbicycles.json();
      setDroppoints(datadroppoints);
      setBicycles(databicycles);
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();

    const autoR = setInterval(() => {
      getData();
    }, 15 * 60 * 1000);

    return () => clearInterval(autoR);
  }, []);

  function splitItems() {
    const chunkSize = 5;

    for (var i = 0; i < droppoints.length; i += chunkSize) {
      const newarr = droppoints.slice(i, i + chunkSize);
      carousels.push(newarr);
    }
  }

  splitItems();

  function returnValue(obj, id) {
    return `${obj[id]}`;
  }

  return (
    <>
      <Card  style={{height: "100%", display: "block"}}>
        <Card.Header className="fw-bold text-center fs-5">
          Droppoints
        </Card.Header>
        <Card.Body>
          {loading ? (
            <ClipLoader
              color="#5b36d6"
              loading={loading}
              cssOverride={override}
              speedMultiplier="0.8"
              size={35}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          ) : (
            <Carousel controls={false} indicators={false} slide={false}>
              {carousels.map((name, key) => (
                <Carousel.Item key={`group_${key}`} interval={nexttime}>
                  <Col>
                    {name.map((item) => (
                      <Card
                        key={item.publicGuid}
                        style={{ overflow: "hidden", marginBottom: "1.2em" }}
                      >
                        <Card.Header className="text-center">
                          <b>{item.name}</b>
                        </Card.Header>
                        <Card.Body className="text-center">
                          {item.postcode != null ? `${item.postcode},` : ""}{" "}
                          {item.city != null ? `${item.city}` : ""}
                        </Card.Body>
                        {item.vehicleKind === 0 ? (
                          <div>
                            <div className="icons_bikes">
                              <img
                                src="/img/icons/bicycles/bike.svg"
                                alt=""
                              ></img>
                              <img
                                src="/img/icons/bicycles/electric.svg"
                                alt=""
                              ></img>
                            </div>
                            <Card.Text className="text-center">
                              Elektrisch
                            </Card.Text>
                          </div>
                        ) : (
                          ""
                        )}
                        {item.vehicleKind === 1 ? (
                          <div>
                            <div className="icons_bikes">
                              <img
                                src="/img/icons/bicycles/bike.svg"
                                alt=""
                              ></img>
                            </div>
                            <Card.Text className="text-center">
                              Regulier
                            </Card.Text>
                          </div>
                        ) : (
                          ""
                        )}
                        <Card.Body className="text-center">
                          {bicycles.hired.hasOwnProperty(item.id.toString()) ===
                          true ? (
                            <div>
                              {returnValue(bicycles.available, item.id)} fietsen
                              beschikbaar
                              <br />
                              {returnValue(bicycles.hired, item.id)} fietsen
                              verhuurd
                            </div>
                          ) : (
                            "Geen data beschikbaar"
                          )}
                        </Card.Body>
                      </Card>
                    ))}
                  </Col>
                </Carousel.Item>
              ))}
            </Carousel>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default SliderDroppoints;
